export default __webpack_public_path__ + "static/media/logo_2.006d9d24.png";